import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_SERVICES_LINKS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetAppServicesResult, IGetAppServicesParams } from '../types/getAppServices.types';

export const getPublicAppServices = (builder: BuilderType) =>
  builder.query<GetAppServicesResult, IGetAppServicesParams>({
    query: (data: IGetAppServicesParams) => ({
      data,
      method: 'POST',
      url: GET_PUBLIC_SERVICES_LINKS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetAppServicesResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
